import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectTemplatesActiveTab,
  selectTemplatesFacetCampaigns,
  selectTemplatesFacetTags,
  selectTemplatesFacetTagsExclude,
  selectTemplatesFacetStatus,
  selectTemplatesFacetChannels,
  selectTemplatesFacetLanguage,
  selectTemplatesFacetType,
  selectTemplatesFilters,
  selectTemplatesTagsMode,
  selectTemplatesTenantAdditionalLanguages,
  templatesFiltersChanged,
  templatesTagsModeChanged,
} from '../../../../../features/templates/store/templatesSlice';
import { buildFilterSections } from '../lib/filterHelpers';
import { toggleFiltersByOptionKey } from '../lib/toggleFiltersByOptionKey';

export function useFiltersPanel() {
  const dispatch = useDispatch();
  const activeTab = useSelector(selectTemplatesActiveTab);
  const filters = useSelector(selectTemplatesFilters);
  const tagsMode = useSelector(selectTemplatesTagsMode);
  const tagsInclude = useSelector(selectTemplatesFacetTags);
  const tagsExclude = useSelector(selectTemplatesFacetTagsExclude);
  const tags = tagsMode === 'exclude' ? tagsExclude : tagsInclude;
  const typeOptions = useSelector(selectTemplatesFacetType);
  const channelOptions = useSelector(selectTemplatesFacetChannels);
  const statusOptions = useSelector(selectTemplatesFacetStatus);
  const campaignOptions = useSelector(selectTemplatesFacetCampaigns);
  const languageOptions = useSelector(selectTemplatesFacetLanguage);
  const tenantAdditionalLanguages = useSelector(selectTemplatesTenantAdditionalLanguages);

  const [tagsSearch, setTagsSearch] = useState('');

  const hasActiveFilters =
    Object.values(filters).some((arr) => arr.length > 0) || tagsSearch.trim().length > 0;

  const filterSections = buildFilterSections({
    activeTab,
    channelOptions,
    typeOptions,
    statusOptions,
    campaignOptions,
    languageOptions,
    tenantAdditionalLanguages,
  });

  const toggleOption = useCallback(
    (optionKey) => {
      dispatch(templatesFiltersChanged(toggleFiltersByOptionKey(filters, optionKey)));
    },
    [dispatch, filters],
  );

  const setTagsMode = useCallback(
    (nextMode) => {
      dispatch(templatesTagsModeChanged(nextMode));
    },
    [dispatch],
  );

  const resetFilters = useCallback(() => {
    dispatch(templatesFiltersChanged(null));
    dispatch(templatesTagsModeChanged('include'));
    setTagsSearch('');
  }, [dispatch]);

  return {
    filters,
    tags,
    tagsMode,
    setTagsMode,
    filterSections,
    tagsSearch,
    setTagsSearch,
    hasActiveFilters,
    toggleOption,
    resetFilters,
  };
}
